import React from "react";
import { useTranslation } from '../hooks/useTranslation';

export const About = () => {
  const { translate } = useTranslation();

  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img src="img/about.jpg" className="img-responsive" alt="" />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>{translate('about_title')}</h2>
              <p>{ translate('header_paragraph')}</p>
              <h3>{translate('why_choose_us')}</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                      <li key={`why11`}>{translate('about_why_1')}</li>
                      <li key={`why12`}>{translate('about_why_2')}</li>
                      <li key={`why13`}>{translate('about_why_3')}</li>
                      <li key={`why14`}>{translate('about_why_4')}</li>
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    <li key={`why21`}>{translate('about_why2_1')}</li>
                      <li key={`why22`}>{translate('about_why2_2')}</li>
                      <li key={`why23`}>{translate('about_why2_3')}</li>
                      <li key={`why24`}>{translate('about_why2_4')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
